<template>
  <el-drawer
    title="留言详情"
    :visible.sync="isShow"
    :before-close="handleDrawerClose"
    :destroy-on-close="false"
    class="message-detail-drawer"
    size="70%"
    :wrapperClosable="false">
    <div class="message-detail-wrapper">
      <el-descriptions :column="1" border labelClassName="label-box">
        <el-descriptions-item label="平台类型">{{ $getPlatformName(detail.platformType) }}</el-descriptions-item>
        <el-descriptions-item label="平台账号">{{detail.platformAccount}}</el-descriptions-item>
        <el-descriptions-item label="手机号">
          <div class="flex-common-style">
            {{ detail.encryptionPhone }}
            <p class="cursor blue ml10" @click="seePhone(detail.phone)" v-if="phoneViewStatus === 0">查看</p>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="留言时间">{{detail.createTime}}</el-descriptions-item>
        <el-descriptions-item label="处理状态">
          <el-tag v-if="getHandleStatus(detail.handerStatus)" size="medium" :type="getHandleStatus(detail.handerStatus).color">{{getHandleStatus(detail.handerStatus).name}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="留言信息">{{detail.noteInfo}}</el-descriptions-item>
        <el-descriptions-item label="跟进人">{{detail.handerPeopleName}}</el-descriptions-item>
        <el-descriptions-item label="跟进记录">
          <div class="handle-record-list" v-if="detail.followUpRecords && detail.followUpRecords.length > 0">
            <div class="handle-record-item" v-for="(item, index) in detail.followUpRecords || []" :key="index">
              <div class="handle-time">{{ item.createTime }}</div>
              <div class="handle-detail">{{ item.resultRemark }}</div>
            </div>
          </div>
          <div class="no-record-tips" v-else>暂无跟进记录</div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="btns-area">
        <el-button type="primary" @click="openAdd" v-if="detail.handerStatus === 3" :disabled="detail.followUpRecords.length >= maxRecordLength">
          新增跟进记录
          <span v-if="detail.followUpRecords.length >= maxRecordLength">【最多{{maxRecordLength}}条】</span>
        </el-button>
        <el-button type="primary" v-if="detail.handerStatus === 3" @click="finish" :loading="isFinishLoading">处理完成</el-button>
      </div>
    </div>
    <el-dialog
      title="新增跟进记录"
      :visible.sync="isAddShow"
      width="600px"
      :close-on-click-modal="false"
      :before-close="handleAddClose"
      append-to-body
      :destroy-on-close="true">
      <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="120px">
        <el-form-item label="处理时间:" prop="handerTime">
          <el-date-picker
            v-model="addForm.handerTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择处理时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结果备注:" prop="resultRemark">
          <el-input
            type="textarea"
            v-model="addForm.resultRemark"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAddClose" :loading="isAddSubmitLoading">取消</el-button>
        <el-button type="primary" @click="onAddSubmit" :loading="isAddSubmitLoading">确定</el-button>
      </span>
    </el-dialog>
  </el-drawer>
</template>

<script>
import {queryIMNoteRecordById, imNoteRecordSetHanderStatus, addImNoteFollowUpRecord} from '../../api/message/index'
export default {
  name: 'MessageDetailDrawer',
  props: ['isShow', 'id'],
  watch: {
    isShow (val) {
      if (val) {
        this.queryIMNoteRecordById()
        this.addForm.noteRecordId = this.id
      }
    }
  },
  computed: {
    myUserInfo () {
      return this.$store.state.Auth.userInfo
    }
  },
  data () {
    return {
      // 最大跟进记录数,
      maxRecordLength: 10,
      isAddSubmitLoading: false,
      isAddShow: false,
      addFormRules: {
        handerTime: [{ required: true, message: '请选择处理时间', trigger: ['blur', 'change'] }],
        resultRemark: [{ required: true, message: '请输入结果备注', trigger: ['blur', 'change'] }]
      },
      addForm: {
        noteRecordId: '',
        handerTime: '',
        resultRemark: ''
      },
      handleStatusConfig: [
        {
          name: '待分配',
          value: 1,
          color: 'danger'
        },
        {
          name: '待处理',
          value: 2,
          color: 'warning'
        },
        {
          name: '处理中',
          value: 3,
          color: 'warning'
        },
        {
          name: '已完成',
          value: 4,
          color: 'success'
        }
      ],
      phoneViewStatus: global.$siderItem.phoneViewStatus,
      isFinishLoading: false,
      // id: this.$route.params.id,
      detail: {
        followUpRecords: []
      }
    }
  },
  methods: {
    // 新增跟进记录
    onAddSubmit () {
      this.$refs.addFormRef.validate(valid => {
        if (valid) {
          addImNoteFollowUpRecord(this.addForm).then(res => {
            if (res.data.resultCode === 0) {
              this.$message.success('添加成功')
              this.queryIMNoteRecordById()
              this.handleAddClose()
            } else {
              this.$message.error(res.data.resultMessage)
            }
          })
        }
      })
    },
    openAdd () {
      this.isAddShow = true
    },
    handleAddClose () {
      this.isAddShow = false
      this.$refs.addFormRef.resetFields()
    },
    handleDrawerClose () {
      // this.$emit('update:isShow', false)
      this.$emit('close')
    },
    getHandleStatus (value) {
      let item = this.handleStatusConfig.find(item => item.value === value)
      return item || null
    },
    // 查看手机号
    seePhone (phone) {
      this.$alert(phone, '提示', {showConfirmButton: false, closeOnClickModal: true})
    },
    finish () {
      this.$confirm('确定将该留言状态改为 已完成 吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.imNoteRecordSetHanderStatus()
      }).catch(() => {
      })
    },
    imNoteRecordSetHanderStatus () {
      let data = {
        handerStatus: 4,
        id: this.id
      }
      this.isFinishLoading = true
      imNoteRecordSetHanderStatus(data).then(res => {
        this.isFinishLoading = false
        if (res.data.resultCode === 0) {
          this.$message.success('操作成功')
          this.queryIMNoteRecordById()
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.isFinishLoading = false
      })
    },
    queryIMNoteRecordById () {
      let data = {
        id: this.id,
        phoneViewStatus: this.phoneViewStatus
      }
      queryIMNoteRecordById(data).then(res => {
        if (res.data.resultCode === 0) {
          let data = res.data.resultData
          this.detail = {
            ...data,
            followUpRecords: data.followUpRecords || []
          }
        } else {
          this.$message.error(res.data.resultMessage)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.message-detail-drawer {
  /deep/.el-drawer__header{
    font-size: 20px;
    font-weight: 500;
  }
  /deep/.el-drawer__body{
    overflow-y: auto;
  }
  .message-detail-wrapper{
    padding: 0 20px 50px;
    font-size: 14px;
    /deep/.label-box{
      width: 150px;
    }
    .handle-record-list{
      .handle-record-item{
        margin-bottom: 10px;
        .handle-time{
          color: #909399;
          margin-bottom: 2px;
        }
      }
    }
    .no-record-tips{
      color: #999;
    }
    .btns-area{
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Message/MessageDetailDrawer.vue